

export class EditSystemUserForm {
  public password: string = '';
  public passwordConf: string = '';
  public quota: number = 0;
  public quotaMultiplier: number = 1;
  public expireDate?: Date = undefined;
}
